module.exports = __webpack_public_path__ + "static/media/insta.0e84d592.png";